<div class="spinner" [class.tiny]="tiny"></div>
